import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { AppLinks, appResponse } from "@/util";
import AppartmentCard from "./appartmentCard";
import FootPagination from "../listings/footPagination";
import { AppSize, pxToRem } from "@/util";
import { ExtendedPortfolio } from "@/util/types/portfolio";
import { usePathname, useRouter } from "next/navigation";
type props={
  error:string,
  isLoading:boolean,
  isError:boolean,
  data:appResponse<ExtendedPortfolio[]>,
  setPage:(e:number)=>void
}
export default function Appartments({error,isLoading,isError,data,setPage}:Partial<props>) {
  const { classes } = styles();
  const router = useRouter();
  const pathname = usePathname();
  

  if (isError) {
    return (
      <Box className={classes.container} justifyContent="center">
        <Typography color="error">Error: {error}</Typography>
      </Box>
    );
  }

  if (!data?.payload?.length && !isLoading) {
    return (
      <Box className={classes.container}>
        <Typography>No apartments found.</Typography>
      </Box>
    );
  }

    const handlePageChange = (e: React.ChangeEvent<unknown>, value: React.SetStateAction<number>) => {
       if (setPage)setPage(value as number);
        if (value === 1) {
        router.push(`${pathname}`);
        } else {
          const params=new URLSearchParams({page:value.toString()});
          //params.set('page',value.toString());
         router.replace(`${pathname}?${params.toString()}`)
       
        }
      };

  return (
    <Box className={classes.container}>
      {isLoading ? (
        <Box className={classes.sub}>
          {[1, 2].map((apartment, i) => (
            <Skeleton key={i} className={classes.skel} />
          ))}
        </Box>
      ) : (
        <Box className={classes.sub}>
          {data &&
            data.payload.map((apartment, i) => (
              <AppartmentCard
                key={i}
                action={() =>
                  router.push(`${AppLinks.PUBLIC.PORTFOLIOS}/${apartment._id}`)
                }
                apartment={{
                  name: apartment.name,
                  city: apartment.city,
                  description: apartment.description,
                  details: apartment.details,
                  image: apartment.image,
                  // location: `${apartment.city || "Unknown City"}`,
                  //propertyType: apartment.details.split(",")[0] || "N/A", // crude extract
                }}
              />
            ))}
        </Box>
      )}

       <FootPagination page={Number.parseInt(`${data?.metadata?.page||"1"}`)} isDivider={false} onChange={handlePageChange} count={data?.metadata?.total?Math.ceil(Number.parseInt(`${data.metadata?.total}`)/Number.parseInt(`${data.metadata?.limit}`)):0}/>
      
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    minHeight: pxToRem(500),
    padding: pxToRem(AppSize.padding),
    [theme.breakpoints.down("sm")]: {
      padding: `${pxToRem(30)}
      ${pxToRem(20)}`,
    },
  },
  sub: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(4),
    },
  },
  skel: {
    height: pxToRem(400),
    display: "flex",
  },
}));
